import { Inbox, Star, Trash2, Settings, Shield, Info } from 'lucide-react';
import { cn } from '@/lib/utils';
import { AdBanner } from '@/components/AdBanner';

interface SidebarProps {
  unreadCount: number;
  isOpen: boolean;
  onClose: () => void;
}

const navItems = [
  { icon: Inbox, label: 'Inbox', active: true },
  { icon: Star, label: 'Starred', active: false },
  { icon: Trash2, label: 'Trash', active: false },
];

export const Sidebar = ({ unreadCount, isOpen, onClose }: SidebarProps) => {
  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-background/80 backdrop-blur-sm z-40 lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <aside
        className={cn(
          'fixed lg:static inset-y-0 left-0 z-50 w-64 glass-strong border-r border-border/50 flex flex-col transition-transform duration-300 lg:translate-x-0',
          isOpen ? 'translate-x-0' : '-translate-x-full'
        )}
      >
        <div className="p-4 lg:pt-6">
          <nav className="space-y-1">
            {navItems.map((item) => (
              <button
                key={item.label}
                className={cn(
                  'w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-all duration-200',
                  item.active
                    ? 'bg-primary/10 text-primary border border-primary/20'
                    : 'text-muted-foreground hover:bg-secondary hover:text-foreground'
                )}
              >
                <item.icon className="w-5 h-5" />
                <span>{item.label}</span>
                {item.label === 'Inbox' && unreadCount > 0 && (
                  <span className="ml-auto px-2 py-0.5 text-xs font-semibold rounded-full gradient-bg text-primary-foreground">
                    {unreadCount}
                  </span>
                )}
              </button>
            ))}
          </nav>
        </div>

        {/* Ad Banner */}
        <div className="px-4 py-2">
          <div className="rounded-xl bg-secondary/30 border border-border/30 p-2 flex justify-center overflow-hidden">
            <AdBanner />
          </div>
        </div>

        {/* Info Section */}
        <div className="mt-auto p-4 border-t border-border/50">
          <div className="p-4 rounded-xl bg-secondary/50 border border-border/50">
            <div className="flex items-center gap-2 mb-2">
              <Shield className="w-4 h-4 text-primary" />
              <span className="text-sm font-medium">Privacy First</span>
            </div>
            <p className="text-xs text-muted-foreground leading-relaxed">
              Your emails are encrypted and automatically deleted after 24 hours. No tracking, no logs.
            </p>
          </div>
        </div>
      </aside>
    </>
  );
};
